import { Controller, useFormContext } from "react-hook-form";

import { Checkbox } from "@smart/itops-sb-design-system-dom";

type HeaderDisplayProps = {
  disabled?: boolean;
};

export const HeaderDisplay = ({ disabled }: HeaderDisplayProps) => {
  const { control } = useFormContext();

  return (
    <div className="flex flex-col gap-small">
      <div className="text-paragraph font-semibold">Header Display</div>
      <Controller
        control={control}
        name="headerDisplay.firmLogo"
        render={({ field, fieldState }) => (
          <Checkbox
            label="Firm Logo"
            checked={field.value}
            onChange={(checked) => field.onChange(checked)}
            error={!!fieldState.error?.message}
            disabled={disabled}
          />
        )}
      />
      <Controller
        control={control}
        name="headerDisplay.firmName"
        render={({ field, fieldState }) => (
          <Checkbox
            label="Firm Name"
            checked={field.value}
            onChange={(checked) => field.onChange(checked)}
            error={!!fieldState.error?.message}
            disabled={disabled}
          />
        )}
      />
    </div>
  );
};
